//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useContext } from 'react';
import './styles.scss';
import { MultiCheckContext } from './context';
import cn from 'classnames';
import { ReactComponent as InactiveSVG } from '../../../assets/images/Subtract.svg';
import { Typography } from '../../typography-voery/Typography';
import { ActiveIcon } from 'src/onboarding/assets/icons/ActiveIcon';

export const MultiOption = ({ children, value }) => {
  const { handleChange, currentValue } = useContext(MultiCheckContext);

  const isActive = currentValue.findIndex((v) => v === value) !== -1;

  return (
    <div
      className={cn('multi-option', { 'multi-active': isActive })}
      onClick={() => {
        handleChange(value);
      }}
    >
      <Typography variant='body-semibold' className={'option-text'}>
        {children}
      </Typography>
      {currentValue.findIndex((v) => v === value) !== -1 ? <ActiveIcon /> : <InactiveSVG />}
    </div>
  );
};
